const COLORS = Object.freeze({
  grays: Object.freeze({
    black: '#000000',
    gray80: '#323232',
    gray55: '#717171',
    gray25: '#bebebe',
    gray12: '#e1e2e3',
    gray6: '#edeeef',
  }),
  // lower numbers = darker colors
  reds: Object.freeze({
    red1: '#ce3139',
    red2: '#ee3a43',
    red3: '#f48474',
    red4: '#f8aa99',
    red5: '#fcd6ca',
  }),
  blues: Object.freeze({
    blue1: '#0079ae',
    blue2: '#0098db',
    blue3: '#95cbee',
    blue4: '#c9e2f5',
    blue5: '#e6eff9',
  }),
  greens: Object.freeze({
    green1: '#52a045',
    green2: '#63bc51',
    green3: '#a2d292',
    green4: '#c6e2ba',
    green5: '#e6f2e1',
  }),
  oranges: Object.freeze({
    orange1: '#e29320',
    orange2: '#f9a224',
    orange3: '#fdc47c',
  }),
  yellows: Object.freeze({
    yellow1: '#edc639',
    yellow2: '#ffd63d',
  }),
  wines: Object.freeze({
    wine1: '#bb2b77',
    wine2: '#d991b2',
  }),
  champagnes: Object.freeze({
    champagne1: '#eee2bd',
    champagne2: '#f5eeda',
  }),
  mansion: Object.freeze({
    mansion1: '#c3a730',
    mansion2: '#bfb980',
    mansion3: '#dedab9',
  }),
  transparent: Object.freeze({
    transparent: 'rgba(0, 0, 0, 0)',
  }),
});

const NEUTRALS = [
  COLORS.mansion.mansion2,
  COLORS.mansion.mansion3,
  COLORS.grays.gray55,
  COLORS.grays.gray25,
  COLORS.grays.gray12,
];

const flattenColors = (colors) =>
  Object.values(colors).reduce((flat, value) => {
    if (typeof value === 'object' && !Array.isArray(value)) {
      // Recursively flatten nested objects
      return [...flat, ...flattenColors(value)];
    }
    return [...flat, value]; // Add the color value directly
  }, []);

export const DJ_RISKJOURNAL_COLORS = Object.freeze(flattenColors(COLORS));

export const DJ_RISKJOURNAL_THEME = Object.freeze({
  name: 'Blue Theme',
  theme: Object.freeze([COLORS.blues.blue1, COLORS.blues.blue2, COLORS.blues.blue3, ...NEUTRALS]),
});

export const DJ_RISKJOURNAL_RED_THEME = Object.freeze({
  name: 'Red Theme',
  theme: Object.freeze([COLORS.reds.red1, COLORS.reds.red2, COLORS.reds.red5, ...NEUTRALS]),
});

export const DJ_RISKJOURNAL_GREEN_THEME = Object.freeze({
  name: 'Green Theme',
  theme: Object.freeze([
    COLORS.greens.green1,
    COLORS.greens.green2,
    COLORS.greens.green4,
    ...NEUTRALS,
  ]),
});

export const DJ_RISKJOURNAL_GOLD_THEME = Object.freeze({
  name: 'Gold Theme',
  theme: Object.freeze([
    COLORS.mansion.mansion1,
    COLORS.yellows.yellow1,
    COLORS.champagnes.champagne1,
    COLORS.grays.gray25,
    COLORS.grays.gray80,
    COLORS.grays.gray55,
    COLORS.grays.gray12,
    COLORS.blues.blue3,
  ]),
});

export const DJ_RISKJOURNAL_COLOR_THEMES = Object.freeze({
  djriskjournal: DJ_RISKJOURNAL_THEME,
  djriskjournal_red: DJ_RISKJOURNAL_RED_THEME,
  djriskjournal_green: DJ_RISKJOURNAL_GREEN_THEME,
  djriskjournal_gold: DJ_RISKJOURNAL_GOLD_THEME,
});

export const DJ_RISKJOURNAL_PLOT_LINE_COLORS = [COLORS.grays.gray80, COLORS.grays.gray25];
